import { Button, Modal, Text } from '@inflearn/ds-react-next';

import type { EnvironmentGuideVariant } from './utils/getEnvironmentGuideVariant';

const GUIDE_CONTENT: Record<EnvironmentGuideVariant, { title: string; description: string }> = {
  narrowScreen: {
    title: '화면 너비를 넓혀주세요.',
    description:
      '화면 너비가 좁으면 화면이 정상적으로 보이지 않을 수 있어요. 화면 너비를 넓혀주세요.',
  },
};

interface MockInterviewEnvironmentGuideModalProps {
  opened: boolean;
  onClose: () => void;
  variant: EnvironmentGuideVariant;
}

export function MockInterviewEnvironmentGuideModal({
  opened,
  onClose,
  variant,
}: MockInterviewEnvironmentGuideModalProps) {
  const { title, description } = GUIDE_CONTENT[variant];

  return (
    <Modal.Root opened={opened} onClose={onClose} size="md" radius={16}>
      <Modal.Overlay />
      <Modal.Content>
        <Modal.Header>
          <Modal.Title>{title}</Modal.Title>
          <Modal.CloseButton />
        </Modal.Header>
        <Modal.Body>
          <Text fz={16} fw={500} c="gray.9">
            {description}
          </Text>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="filled" color="infgreen" size="md" radius="md" onClick={onClose}>
            확인
          </Button>
        </Modal.Footer>
      </Modal.Content>
    </Modal.Root>
  );
}
